<template>
	<div class="copyright_area">
		<footer id="footer_area">
			<div class="container">
				<div class="row">
					<div class="col-lg-3 col-md-6 col-sm-12 mb-5 mb-sm-0">
						<div class="footer_heading_area">
							<h5>{{ $t("need_help") }}</h5>
						</div>
						<div class="footer_first_area mb-5">
							<div class="footer_inquery_area">
								<h5>{{ $t("available") }}</h5>
								<h4><a href="tel:+57 310 8017473">+57 310 8017473</a></h4>
							</div>
							<div class="footer_inquery_area">
								<h5>{{ $t("send_email") }}</h5>
								<h4>
									<a href="mailto:soporte@selahcomfort.com">soporte@selahcomfort.com</a>
								</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-12 mb-5 mb-sm-0">
						<div class="footer_heading_area">
							<h5>{{ $t("us") }}</h5>
						</div>
						<div class="footer_link_area">
							<ul>
								<li>
									<router-link to="/about-us">{{ $t("about_us") }}</router-link>
								</li>
								<li>
									<router-link to="/testimonials">{{
										$t("testimonials")
									}}</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-12 mb-5 mb-sm-0">
						<div class="footer_heading_area">
							<h5>{{ $t("support") }}</h5>
						</div>
						<div class="footer_link_area">
							<ul>
								<li>
									<router-link to="/faqs">{{
										$t("frequently_asked_questions")
									}}</router-link>
								</li>
								<li>
									<router-link to="/contact">{{
										$t("contact_us")
									}}</router-link>
								</li>
								<li>
									<router-link to="/privacy-policy">{{
										$t("privacy_policies")
									}}</router-link>
								</li>
								<li>
									<router-link to="/terms-service">{{
										$t("terms_and_conditions")
									}}</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-12 mb-5 mb-sm-0">
						<div class="footer_heading_area">
							<h5>{{ $t("register_footer") }}</h5>
						</div>
						<div class="footer_link_area">
							<ul>
								<li>
									<router-link to="/register#hotels">
										{{ $t("profitable_unit") }}
									</router-link>
								</li>
								<li>
									<router-link to="/register#interest-places">{{
										$t("register_place_interest")
									}}</router-link>
								</li>
								<li>
									<router-link to="/register#travel-agency">{{
										$t("travel_agency")
									}}</router-link>
								</li>
								<li>
									<router-link to="/register#trips">{{
										$t("trips_in_selah")
									}}</router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="container my-5 my-sm-0">
				<div class="row ">
					<div class="col-lg-3 col-md-6 col-sm-12 ">
						<img class="log-footer" src="../assets/img/Selah-Netgativo-409x405.png" alt="img" />
					</div>

					<div class="col-lg-3 text-footer-baseline col-md-6 col-sm-12 ">
						<div>
							<h5 class="text-white">{{ $t("follow_us") }}</h5>
							<ul class="social_media_footer d-flex">
								<li>
									<a target="_blank" href="https://www.facebook.com/Selahcomfort"><i
											class="fab fa-facebook-f"></i></a>
									<a target="_blank" href="https://www.tiktok.com/@selahcomfort"><i
											class="fa-brands fa-tiktok"></i></a>
									<a target="_blank" href="https://www.youtube.com/@selahcomfort"><i
											class="fa-brands fa-youtube"></i></a>
									<a target="_blank" href="https://instagram.com/selahcomfort_"><i
											class="fab fa-instagram"></i></a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-12 ">
						<div class="text-footer-baseline">
							<a class="text-white" href="tel:+57 310 8017473">+57 310 8017473</a>
						</div>
					</div>
					<div class="col-lg-3 col-md-6  col-sm-12 ">
						<div class="text-footer-baseline">
							<a class="text-white" href="mailto:contacto@selahcomfort.com">contacto@selahcomfort.com</a>
						</div>
					</div>
				</div>
				<div class="text-center my-4">
					<p class="text-white">
						Copyright <span class="text-coral">©</span> {{ currentYear }}
						{{ $t("copyright") }}
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	name: "Footer",
	data() {
		return {
			currentYear: new Date().getFullYear(),
		};
	},
};
</script>
